// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2hu_k","container":"styles_container__3Nf03","title":"styles_title__2ny43","wrapper":"styles_wrapper__34TsO","answer":"styles_answer__2RqXx"};